<div class="select-box">
    <div class="option d-flex align-items-center">
      <input
        id="option"
        type="checkbox"
        name="option"
        [(ngModel)]="option"
        (change)="onOptionChange()"
      />
      <label for="option" class="custom-checkbox"></label>
      <span class="title">{{ title }}</span>
    </div>
  </div>
  